 

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface EmployeeParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Employee {
    name?: string;
    id?: string;
    empNumber: string
    firstName: string;
    lastName: string;
    age: string;
    dob?: Date;
    gender: string;
    workPhone: string;
    mobile: string;
    altMobile: string;
    maritalstatus: string;
    email: string;  
    fathername: string;
    spousename: string;
    area: string;
    jobCategoryId?:number;
    city: string;
    country: string;
    district: string;
    doj?: Date;
    dol?: Date;
    accountNo: string;
    tenantId: string;
    departmentId: string;
    designationId: string;
    bankId: string;
    bank?:any;
    department?:any;
    designation?:any;
    branchName:string;
    state:string;
    pincode?:number;
    ifscCode:string;
    salary?:number;
    streetName:string;
    title:string;
    employeeType:string;
    branchId:string;
    isActive?:string
    signatureEnabled?:string
    mobileCountryCode:string,
    altMobileCountryCode:string,
    organizationId?:number,
    villageId?: number,   
}
export interface GenderOptions {
  value: number;
  title: string;
}

export interface TitleOptions {
  value: number;
  title: string;
}

export abstract class EmployeeData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract reflist(url: string): Observable<any[]>; 

  abstract list(url: string): Observable<Employee[]>;
  abstract create(url: string,data: Employee): Observable<any>;
  abstract update(url: string,data: Employee): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
